import { render } from "./TickBox.vue?vue&type=template&id=8a95ce1e&scoped=true"
import script from "./TickBox.vue?vue&type=script&lang=js"
export * from "./TickBox.vue?vue&type=script&lang=js"

import "./TickBox.vue?vue&type=style&index=0&id=8a95ce1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a95ce1e"]])

export default __exports__